// extracted by mini-css-extract-plugin
export default {"OrdersPage":"OrdersPage_OrdersPage__S+f6X"};